const getFileTypeFromUrl = (url: string): string => {
  const imageRegex = /\.(png|jpg|jpeg|apng|avif|gif|svg|webp)\?uuid=/;
  const imageMatch = url.match(imageRegex);

  if (imageMatch) {
    const imageExtension = imageMatch[1].toLowerCase();
    if (imageExtension === 'svg') {
      return 'image/svg+xml';
    } else {
      return `image/${imageExtension}`;
    }
  }

  const videoRegex = /\.(mp4|mov|quicktime)\?uuid=/;
  const videoMatch = url.match(videoRegex);

  if (videoMatch) {
    const videoExtension = videoMatch[1].toLowerCase();
    return `video/${videoExtension}`;
  }

  return 'image/png';
};

export default getFileTypeFromUrl;
